import React, { useContext } from "react";
import Loader from "react-loader-spinner";

//global state
import { StateContext } from "../../AppStateContext";

//style
import "./Module.css";

//material ui stuff
import Tooltip from "@material-ui/core/Tooltip";
import LinkIcon from "@material-ui/icons/Link";
import AssignmentIcon from "@material-ui/icons/Assignment";

// Material UI imports
import { MyCheckboxComponent } from "../../materialUiComponents";

const options = [
  {
    value: "false",
  },
];

const ShareQueryButton = ({ state, shareQueryInputRef, copyToClipBoard, theme, getShareText, toggleIsUrlPrettified }) => {
  //consume global state
  const appState = useContext(StateContext);
  return (
    <div>
      {state.shareQueryToggle ? (
        <div className="__shareQueryOuterDiv">
          <div>
            <input
              readOnly
              type="text"
              value={state.shareQueryString}
              className="__shareQueryInput"
              id="shareQueryInput"
              ref={shareQueryInputRef}
            />
            <Tooltip placement="bottom-start" title="Click to copy the link to this GraphQL query to your clipboard.">
              <AssignmentIcon
                id="shareQueryClipBoardIcon"
                onClick={copyToClipBoard}
                style={{
                  color: theme === "dark" ? "#fff" : "#122742",
                  fontSize: "27px",
                  transform: "translateY(10px)",
                  cursor: "pointer",
                }}
              />
            </Tooltip>{" "}
            <small
              id="shareQueryCopiedText"
              className={state.isQueryCopiedToClipBoard ? "__shareQueryCopiedText" : "__hideShareQueryCopiedButton"}
            >
              Copied!
            </small>
          </div>
          <MyCheckboxComponent
            value={String(state.isUrlPrettified)}
            onChange={toggleIsUrlPrettified}
            options={options}
            state={appState}
            helperText="Auto prettify this query"
            smallCheckbox
          />
        </div>
      ) : state.isLoadingBitlyLink ? (
        <button id="shareQueryButton" className="__shareQueryButton __shareQueryButtonLoading" onClick={getShareText}>
          <Loader type="ThreeDots" color="#fff" height={25} width={25} />
        </button>
      ) : (
        <button id="shareQueryButton" className="__shareQueryButton" onClick={getShareText}>
          Share this query <LinkIcon />
        </button>
      )}
    </div>
  );
};

export default ShareQueryButton;
